module.exports = __webpack_public_path__ + "img/trash_blue.ec9aeece.svg";